import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import TwoFactorPage from "./pages/TwoFactorPage";
import DashboardPage from "./pages/DashboardPage";
import ConsultasPage from "./pages/ConsultasPage";
import ConsultaDetailPage from "./pages/ConsultaDetailPage";
import ClientesPage from "./pages/ClientesPage";
import ClienteDetailPage from "./pages/ClienteDetailPage";
import CalendarioPage from "./pages/CalendarioPage";
import UsersPage from "./pages/UsersPage";
import ConfiguracionPage from "./pages/ConfiguracionPage";
import DashboardLayout from "./components/DashboardLayout";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-primary font-heading text-xl">Cargando...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="consultas" element={<ConsultasPage />} />
            <Route path="consultas/:id" element={<ConsultaDetailPage />} />
            <Route path="clientes" element={<ClientesPage />} />
            <Route path="clientes/:id" element={<ClienteDetailPage />} />
            <Route path="calendario" element={<CalendarioPage />} />
            <Route path="usuarios" element={<UsersPage />} />
            <Route path="configuracion" element={<ConfiguracionPage />} />
            <Route path="two-factor" element={<TwoFactorPage />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
